import { useAppContext } from '../../context/AppContext';
import { useCmsText } from '../../hooks/useCmsText';

const CollaborationPartner = () => {
  const { renderText  } = useCmsText();
  const { state } = useAppContext();

  return (
    <div className="flex flex-col mt-10 bg-secondary p-5 py-3 rounded-lg" style={{background: state.branding?.footerBoxBackground}}>
      <div className="flex flex-row items-center justify-center">
        <div className="ml-4">
          <p className="text-xs cms-html">
            {renderText('collaboration_text')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CollaborationPartner;